export default "__VITE_ASSET__$Li2p2$X__"